module.exports = __webpack_public_path__ + "assets/images/outfit-01.414d7089e9789c6bc281a496b907cb31.svg";